import styled from "styled-components";

import { Section } from "../../components/atoms/Section";
import breakpoints from "../../styles/breakpoints";

export const PacksSection = styled(Section)`
  padding-top: 30px !important;
`;

export const PageDescription = styled.p`
  font-size: 18px;
  line-height: 24px;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  ${breakpoints.lgDown} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  ${breakpoints.smDown} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
`;
